/* ============================================================
   Canaletas Nicoll — interacciones de secciones (vanilla JS)
   Selector guiado · clases de carga · filtro de catálogo
   Re-inicializable con los eventos del editor de temas Shopify.
   ============================================================ */
(function () {
  "use strict";

  function initSelector(root) {
    root.querySelectorAll("[data-qs]").forEach(function (card) {
      var stepChoose = card.querySelector("[data-qs-choose]");
      var stepResult = card.querySelector("[data-qs-result]");
      var dots = card.querySelectorAll(".qs-dots i");
      var title = card.querySelector("[data-qs-title]");
      var results = card.querySelectorAll("[data-qs-panel]");

      function show(use) {
        var found = false;
        results.forEach(function (p) {
          var match = p.getAttribute("data-qs-panel") === use;
          p.hidden = !match;
          if (match) found = true;
        });
        if (!found) return;
        stepChoose.hidden = true;
        stepResult.hidden = false;
        if (dots[0]) dots[0].classList.remove("on");
        if (dots[1]) dots[1].classList.add("on");
        if (title) title.textContent = title.getAttribute("data-result-title") || "Tu canaleta ideal";
      }
      function reset() {
        stepChoose.hidden = false;
        stepResult.hidden = true;
        if (dots[0]) dots[0].classList.add("on");
        if (dots[1]) dots[1].classList.remove("on");
        if (title) title.textContent = title.getAttribute("data-choose-title") || "¿Qué canaleta necesito?";
      }
      card.querySelectorAll("[data-qs-opt]").forEach(function (btn) {
        btn.addEventListener("click", function () { show(btn.getAttribute("data-qs-opt")); });
      });
      card.querySelectorAll("[data-qs-back]").forEach(function (b) {
        b.addEventListener("click", reset);
      });
      reset();
    });
  }

  function initLoadClasses(root) {
    root.querySelectorAll("[data-lc]").forEach(function (wrap) {
      var items = wrap.querySelectorAll(".lc-item");
      var visual = wrap.querySelector("[data-lc-visual]");
      if (!visual) return;
      function activate(item) {
        items.forEach(function (i) { i.classList.remove("on"); });
        item.classList.add("on");
        var d = item.dataset;
        visual.querySelector("[data-lc-emoji]").textContent = d.emoji || "";
        var badge = visual.querySelector("[data-lc-code]");
        badge.textContent = d.code || "";
        badge.className = "lc-badge " + (d.cls || "");
        visual.querySelector("[data-lc-ton]").textContent = d.ton ? "hasta " + d.ton : "";
        visual.querySelector("[data-lc-name]").textContent = d.name || "";
        visual.querySelector("[data-lc-desc]").textContent = d.desc || "";
        var ex = visual.querySelector("[data-lc-ex]");
        ex.innerHTML = "";
        (d.examples || "").split("|").forEach(function (e) {
          if (!e.trim()) return;
          var s = document.createElement("span");
          s.textContent = e.trim();
          ex.appendChild(s);
        });
      }
      items.forEach(function (item) {
        item.addEventListener("click", function () { activate(item); });
      });
      var initial = wrap.querySelector(".lc-item.on") || items[0];
      if (initial) activate(initial);
    });
  }

  function initCatalogFilter(root) {
    root.querySelectorAll("[data-catalog]").forEach(function (sec) {
      var chips = sec.querySelectorAll("[data-filter]");
      var cards = sec.querySelectorAll("[data-uses]");
      chips.forEach(function (chip) {
        chip.addEventListener("click", function () {
          chips.forEach(function (c) { c.classList.remove("on"); });
          chip.classList.add("on");
          var f = chip.getAttribute("data-filter");
          cards.forEach(function (card) {
            var uses = card.getAttribute("data-uses") || "";
            card.style.display = (f === "all" || uses.split(",").indexOf(f) > -1) ? "" : "none";
          });
        });
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    initSelector(root);
    initLoadClasses(root);
    initCatalogFilter(root);
  }

  document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  // Theme editor: re-init when a section is loaded/reloaded
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
